module.exports = __webpack_public_path__ + "img/baptisan.4aa8ad83.jpg";